import { render, staticRenderFns } from "./MyQuickQuote.vue?vue&type=template&id=bc9c530a&lang=html&"
import script from "./MyQuickQuote.vue?vue&type=script&lang=js&"
export * from "./MyQuickQuote.vue?vue&type=script&lang=js&"
import style0 from "./MyQuickQuote.vue?vue&type=style&index=0&id=bc9c530a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports